<template>
  <div class="">
    <component
      v-if="componentName"
      :is="componentName"
      :activityId="activityId"
      :isVip="isVip"
    ></component>
    <AppLoading class="app-loading" v-else />
  </div>
</template>

<script>
import AppLoading from '@/components/app/loading/loading.vue'
import SignComponentOne from './activity-1.vue'
import SignComponentTwo from './activity-2.vue'
import SignComponentThree from './activity-3.vue'
import SignComponent4 from './activity-4.vue'
export default {
  name: 'member-sign-in-page',
  components: {
    AppLoading,
    SignComponentOne,
    SignComponentTwo,
    SignComponentThree,
    SignComponent4
  },
  data() {
    return {
      activityId: 0,
      isVip: false,
      componentName: '',
      defaultComponentName: 'SignComponent4',
      componentsData: {
        2: 'SignComponentOne',
        3: 'SignComponentTwo',
        4: 'SignComponentThree',
        5: 'SignComponent4'
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await this.$http
        .getAppWithAppInfo('api/v1/SignActivity/getZeroBuyActivityId', {})
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.activityId = res.data?.activity_id || 0
          this.componentName =
            this.componentsData[this.activityId] || this.defaultComponentName
          if (!this.componentName) {
            this.$toast('活动不存在')
          }
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.app-loading {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
}
</style>
